import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import PuppyCollegeQuote from '../components/PuppyCollegeQuote';

function PuppyCollegeQuoteContainer(props) {
  return (
    <div className="PuppyCollegeQuoteContainer">
      <PuppyCollegeQuote {...props} />
    </div>
  );
}

export default compose(
  connect(({ server }) => ({
    title: server.pageSections.quotes.title,
    quote: server.pageSections.quotes.page_items[0] // Only one item in this list
  }))
)(PuppyCollegeQuoteContainer);
